module.exports = __webpack_public_path__ + "img/8-3.2e1183ab.jpg";